<script>
	import Examples from "../components/Examples.svelte";
	import Faqs from "../components/Faqs.svelte";
	import Tags from "svelte-tags-input";
	let initTags = ["svelte", "tags", "input"];
</script>

<main>
	<header>
		<h1>svelte-tags-input</h1>
		<p>Fully customizable Svelte component to enter tags</p>
		<div class="tag-container">
			<Tags id="hero-tags" tags={initTags} />
		</div>
		<iframe
			src="https://ghbtns.com/github-btn.html?user=agustinl&repo=svelte-tags-input&type=star&count=true"
			frameborder="0"
			scrolling="0"
			width="90"
			height="20"
			title="GitHub"
			style="margin-top: 20px"
		/>
	</header>

	<section>
		<h2>Installation</h2>
		<div class="code-block">
			<pre class="language-bash"><code>npm install svelte-tags-input</code></pre>
		</div>
	</section>

	<section>
		<h2>Usage</h2>
		<div class="code-block">
			<pre class="language-javascript"><code>import Tags from "svelte-tags-input";

&lt;Tags /&gt;</code></pre>
		</div>
	</section>

	<Examples />
	
	<Faqs />
	
	<div class="social">
		<a
			href="https://www.npmjs.com/package/svelte-tags-input"
			rel="noopener noreferrer"
			target="_blank"
			><img src="https://img.shields.io/npm/v/svelte-tags-input.svg" alt="NPM" /></a
		>

		<a
			title="MadeWithSvelte.com Shield"
			rel="noopener noreferrer"
			target="_blank"
			href="https://madewithsvelte.com/p/svelte-tags-input/shield-link"
		>
			<img
				src="https://madewithsvelte.com/storage/repo-shields/2151-shield.svg"
				alt="Made With Svelte"
			/></a
		>
	</div>

	<footer>
		<p>Made by <a
			href="https://twitter.com/agustinlautaro"
			rel="noopener noreferrer"
			target="_blank"
			class="text-yellow-700 font-medium hover:text-yellow-600">Agustín</a
		>.</p>

		<p>{new Date().getFullYear()}</p>
	</footer>

</main>

<style>
@media only screen and (max-width: 540px) {	
	.tag-container :global(.svelte-tags-input-layout) {
		max-width: 100vw;
	}
}
</style>